/**
 * Autosave writes must fail fast rather than hang: the save queue serialises on
 * one in-flight request, so a stalled save blocks every later flush behind it —
 * including the flush on tab hide.
 */
export const SAVE_REQUEST_TIMEOUT_MS = 15000;
